module.exports = __webpack_public_path__ + "img/wheatfield.54f1d8cd.jpg";